module.exports = __webpack_public_path__ + "img/python_book.fda38a69.jpg";